export class RestoreEntraIdWithMicrosoft365Request {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityIds",
            "baseName": "entityIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "entraIdRestoreAccountId",
            "baseName": "entraIdRestoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "microsoft365",
            "baseName": "microsoft365",
            "type": "UnifiedRestoreMicrosoft365Request",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreEntraIdWithMicrosoft365Request.attributeTypeMap;
    }
    constructor() {
    }
}
